import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import BrandManufacturerApi from '@iso/lib/api/brandManufacturerHelper';
import actions from './actions';

export function* brandManufacturerCreateRequest() {
  yield takeEvery(actions.BRAND_MANUFACTURER_ADD_NEW, function* ({ payload }) {
    console.log("payloaddddd",payload);
    const result = yield call(BrandManufacturerApi.create, payload.dataObj);
    console.log("resulttttttpayload",result);
    if (result.status === 0) {
      notification('error', result.message);
    } else {
      console.log("payload.dataObj","200");
      notification('success', result.message);
      yield put({
        type: actions.BRAND_MANUFACTURER_READ,
        success: true,
        msg: result.message,
      });
      window.location.reload(true)
      // payload.history.push('/dashboard/listMaster');
    }
  });
}

export function* brandManufacturerReadRequest() {

  yield takeEvery(actions.BRAND_MANUFACTURER_READ, function* ({ payload }) {
    console.log("payloadddddRead",payload);
    try {
      const searchResult = yield call(BrandManufacturerApi.read, payload.readFilter, payload.page);
      console.log("payloadddddsearchResult",searchResult);
      if (searchResult.status) {
        yield put(
          actions.brandManufacturerReadSearchSuccess(
            searchResult.result,
            true,
            searchResult.totalRecordCount,
            payload.page,
            payload.readFilter
          )
        );
      } else {
        notification('error', searchResult.message);
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
      //  yield put(actions.gitSearchSuccess());
    }
  })
}

export function* brandManufacturerMappingReadRequest() {

  yield takeEvery(actions.BRAND_MANUFACTURER_MAPPING_READ, function* ({ payload }) {
    // console.log("payloadddddRead",payload);
    try {
      const searchResult = yield call(BrandManufacturerApi.readMapping, payload.readFilter, payload.page);
      console.log("payloadddddsearchResult",searchResult);
      if (searchResult.status) {
        yield put(
          actions.brandManufacturerMappingReadSearchSuccess(
            searchResult.result,
            true,
            searchResult.totalRecordCount,
            payload.page,
            payload.readFilter
          )
        );
      } else {
        notification('error', searchResult.message);
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
      //  yield put(actions.gitSearchSuccess());
    }
  })
}



export default function* rootSaga() {
  yield all([
    fork(brandManufacturerCreateRequest),
    fork(brandManufacturerReadRequest),
    fork(brandManufacturerMappingReadRequest)
  ]);
}
